module.exports = __webpack_public_path__ + "static/media/arrow_up.05ff7939.svg";